import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import RequirementsMonitorServices from "./RequirementsMonitor.services";
import { downloadDocument } from "../../../components/gestorDocumental/GestorDocumental";
import { Form } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getRequirementsMonitor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_REQUIREMENTS_MONITOR,
      payload: true,
    });
    const resp = await RequirementsMonitorServices.getRequirementsMonitor(
      filters
    );
    dispatch({
      type: actions.GET_REQUIREMENTS_MONITOR,
      payload: {
        requirementsMonitors: resp.data.data,
        requirementsMonitorsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.REQUIREMENTS_MONITOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.REQUIREMENTS_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUIREMENTS_MONITOR,
      payload: false,
    });
  }
};

export const getRequirementsMonitorById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_REQUIREMENTS_MONITOR_BY_ID,
      payload: true,
    });
    const resp = await RequirementsMonitorServices.getRequirementsMonitorById(
      id
    );
    dispatch({
      type: actions.GET_REQUIREMENTS_MONITOR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.REQUIREMENTS_MONITOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.REQUIREMENTS_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUIREMENTS_MONITOR_BY_ID,
      payload: false,
    });
  }
};

export const getRequirementsUrls = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_REQUIREMENTS_URL,
      payload: true,
    });
    const resp = await RequirementsMonitorServices.getRequirementsUrls(filters);
    dispatch({
      type: actions.GET_REQUIREMENTS_URL,
      payload: resp.data,
    });
    dispatch({
      type: actions.REQUIREMENTS_URL_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.REQUIREMENTS_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUIREMENTS_URL,
      payload: false,
    });
  }
};

export const editRequirementsMonitor =
  (
    data,
    editItem,
    estado,
    index,
    setShowModal,
    file,
    _getRequirementsMonitor
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_MONITOR,
        payload: true,
      });

      const resp = await RequirementsMonitorServices.editRequirementsMonitor(
        editItem.id,
        data
      );
      const { requirementsMonitors, requirementsMonitorsLength } =
        getState().requirementsMonitor;
      requirementsMonitors[index] = resp.data;
      if (file.length > 0) {
        // file.map(async (_file) => {
        //   const dataUrl = new FormData();
        //   dataUrl.append("solicitud", _data.id);
        //   dataUrl.append("nombre_archivo", _file.name);
        //   dataUrl.append("plan_induccion", _file);
        //   await RequirementsMonitorServices.saveRequirementsUrl(dataUrl);
        // }
        // );
        for (let i = 0; i < file.length; i++) {
          const dataUrl = new FormData();
          dataUrl.append("solicitud", requirementsMonitors[index].id);
          dataUrl.append("nombre_archivo", file[i].name);
          dataUrl.append("plan_induccion", file[i]);
          await RequirementsMonitorServices.saveRequirementsUrl(dataUrl);
        }
      }

      _getRequirementsMonitor();

      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      if (data.estado !== editItem.estado) {
        const _data = {
          data: [
            {
              plaza_id: resp.data.id,
              tipo_mensaje: "Cambio de estado de la plaza",
              estado_1: editItem.estado,
              estado_2: estado,
            },
          ],
        };
        const mail = {
          data: [
            {
              plaza_id: resp.data.id,
              tipo_mensaje: "Jefe del Responsable Cambio de estado de la plaza",
              estado_1: editItem.estado,
              estado_2: estado,
            },
          ],
        };
        await RequirementsMonitorServices.mailSendRequirementsMonitor(_data);
        await RequirementsMonitorServices.mailSendRequirementsMonitor(mail);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_MONITOR,
        payload: false,
      });
    }
  };

export const editRequirementsMonitorById =
  (data, id, oldState) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_MONITOR_BY_ID,
        payload: true,
      });
      const resp = await RequirementsMonitorServices.editRequirementsMonitor(
        id,
        { estado: data.id }
      );
      dispatch({
        type: actions.GET_REQUIREMENTS_MONITOR_BY_ID,
        payload: resp.data,
      });
      dispatch({
        type: actions.REQUIREMENTS_MONITOR_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      if (data.id !== oldState) {
        const _data = {
          data: [
            {
              plaza_id: resp.data.id,
              tipo_mensaje: "Cambio de estado de la plaza",
              estado_1: oldState,
              estado_2: data.id,
            },
          ],
        };
        const mail = {
          data: [
            {
              plaza_id: resp.data.id,
              tipo_mensaje: "Jefe del Responsable Cambio de estado de la plaza",
              estado_1: oldState,
              estado_2: data.id,
            },
          ],
        };
        await RequirementsMonitorServices.mailSendRequirementsMonitor(_data);
        await RequirementsMonitorServices.mailSendRequirementsMonitor(mail);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.REQUIREMENTS_MONITOR_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_MONITOR_BY_ID,
        payload: false,
      });
    }
  };

// export const editRequirementsUrl =
//   (data, editItem, estado, index) => async (dispatch, getState) => {
//     try {
//       dispatch({
//         type: actions.LOADING_REQUIREMENTS_URL,
//         payload: true,
//       });
//       const resp = await RequirementsMonitorServices.editRequirementsUrl(
//         editItem.id,
//         data
//       );
//       const { requirementsUrls } = getState().requirementsUrls;
//       requirementsUrls[index] = resp.data;
//       dispatch({
//         type: actions.GET_REQUIREMENTS_URL,
//         payload: {
//           requirementsUrls: requirementsUrls,
//         },
//       });
//       dispatch({
//         type: actions.FORM_URL_FAIL,
//         payload: "",
//       });
//       toastr.success(messages.successMessage, "", {
//         progressBar: true,
//         rtl: true,
//       });
//       // if (data.estado !== editItem.estado) {
//       //   const _data = {
//       //     data: [
//       //       {
//       //         plaza_id: resp.data.id,
//       //         tipo_mensaje: "Cambio de estado de la plaza",
//       //         estado_1: editItem.estado,
//       //         estado_2: estado,
//       //       },
//       //     ],
//       //   };
//       //   const mail = {
//       //     data: [
//       //       {
//       //         plaza_id: resp.data.id,
//       //         tipo_mensaje: "Jefe del Responsable Cambio de estado de la plaza",
//       //         estado_1: editItem.estado,
//       //         estado_2: estado,
//       //       },
//       //     ],
//       //   };
//       //   await RequirementsMonitorServices.mailSendRequirementsMonitor(_data);
//       //   await RequirementsMonitorServices.mailSendRequirementsMonitor(mail);
//       //   toastr.success(messages.correoEnviado, "", {
//       //     progressBar: true,
//       //     rtl: true,
//       //   });
//       // }
//     } catch (ex) {
//       let message = null;
//       if (axios.isAxiosError(ex)) {
//         if (ex.response?.status) {
//           switch (ex.response.status) {
//             case 400:
//               message = messages.errorMessage + " " + ex.response.statusText;
//               break;
//             case 404:
//               message = messages.errorMessage + " " + ex.response.statusText;
//               break;
//             case 500:
//               message = messages.errorMessage + " " + ex.response.statusText;
//               break;
//             default:
//               message = ex.response.data;
//               break;
//           }
//         } else {
//           message =
//             ex.message === "Network Error" ? messages.networkError : ex.message;
//         }
//       } else {
//         message =
//           ex.message === "Network Error" ? messages.networkError : ex.message;
//       }
//       dispatch({
//         type: actions.FORM_URL_FAIL,
//         payload: message,
//       });
//     } finally {
//       dispatch({
//         type: actions.LOADING_REQUIREMENTS_URL,
//         payload: false,
//       });
//     }
//   };

export const saveRequirementsMonitor =
  (data, setShowModal, file, _getRequirementsMonitor) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_REQUIREMENTS_MONITOR,
        payload: true,
      });
      const resp = await RequirementsMonitorServices.saveRequirementsMonitor(
        data
      );
      const { requirementsMonitors, requirementsMonitorsLength } =
        getState().requirementsMonitor;
      const _requirementsMonitor = [...requirementsMonitors, resp.data];
      const _data = resp.data;
      if (file.length > 0) {
        // file.map(async (_file) => {
        //   const dataUrl = new FormData();
        //   dataUrl.append("solicitud", _data.id);
        //   dataUrl.append("nombre_archivo", _file.name);
        //   dataUrl.append("plan_induccion", _file);
        //   await RequirementsMonitorServices.saveRequirementsUrl(dataUrl);
        // }
        // );
        for (let i = 0; i < file.length; i++) {
          const dataUrl = new FormData();
          dataUrl.append("solicitud", _data.id);
          dataUrl.append("nombre_archivo", file[i].name);
          dataUrl.append("plan_induccion", file[i]);
          await RequirementsMonitorServices.saveRequirementsUrl(dataUrl);
        }
      }

      _getRequirementsMonitor();

      // dispatch({
      //   type: actions.GET_REQUIREMENTS_MONITOR,
      //   payload: {
      //     requirementsMonitors: _requirementsMonitor,
      //     requirementsMonitorsLength: requirementsMonitorsLength + 1,
      //   },
      // });

      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const mail = {
        data: [
          {
            plaza_id: _data.id,
            tipo_mensaje: "Jefe solicita vacante",
          },
        ],
      };
      const mail2 = {
        data: [
          {
            plaza_id: _data.id,
            tipo_mensaje: "JefeResponsable: jefe Solicita Vacante",
          },
        ],
      };
      await RequirementsMonitorServices.mailSendRequirementsMonitor(mail);
      await RequirementsMonitorServices.mailSendRequirementsMonitor(mail2);
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_REQUIREMENTS_MONITOR,
        payload: false,
      });
    }
  };

// export const saveRequirementsUrl = (data) => async (dispatch, getState) => {
//   try {
//     dispatch({
//       type: actions.SAVE_LOADING_REQUIREMENTS_URL,
//       payload: true,
//     });
//     const resp = await RequirementsMonitorServices.saveRequirementsUrl(data);
//     // const { requirementsMonitors } = getState().requirementsMonitor;
//     const _requirementsUrls = [...requirementsUrls, resp.data];
//     const _data = resp.data;
//     dispatch({
//       type: actions.GET_REQUIREMENTS_URL,
//       payload: {
//         requirementsMonitors: _requirementsUrls,
//       },
//     });
//     dispatch({
//       type: actions.FORM_URL_FAIL,
//       payload: "",
//     });
//     // setShowModal(false);
//     toastr.success(messages.successMessage, "", {
//       progressBar: true,
//       rtl: true,
//     });
//     // const mail = {
//     //   data:[
//     //     {
//     //       plaza_id:_data.id,
//     //       tipo_mensaje:"Jefe solicita vacante"
//     //     }
//     //   ]
//     // }
//     // const mail2 = {
//     //   data:[
//     //     {
//     //       plaza_id:_data.id,
//     //       tipo_mensaje: "JefeResponsable: jefe Solicita Vacante"
//     //     }
//     //   ]
//     // }
//     // await RequirementsMonitorServices.mailSendRequirementsMonitor(mail)
//     // await RequirementsMonitorServices.mailSendRequirementsMonitor(mail2)
//     // toastr.success(messages.correoEnviado, '', {
//     //   progressBar: true,
//     //   rtl: true,
//     // });
//   } catch (ex) {
//     let message = null;
//     if (axios.isAxiosError(ex)) {
//       if (ex.response?.status) {
//         switch (ex.response.status) {
//           case 400:
//             if (ex.response.data.mensaje) {
//               message = ex.response.data.mensaje;
//             } else {
//               message = messages.errorMessage + " " + ex.response.statusText;
//             }
//             break;
//           case 404:
//             message = messages.errorMessage + " " + ex.response.statusText;
//             break;
//           case 500:
//             message = messages.errorMessage + " " + ex.response.statusText;
//             break;
//           default:
//             message = ex.response.data;
//             break;
//         }
//       } else {
//         message =
//           ex.message === "Network Error" ? messages.networkError : ex.message;
//       }
//     } else {
//       message =
//         ex.message === "Network Error" ? messages.networkError : ex.message;
//     }
//     dispatch({
//       type: actions.FORM_URL_FAIL,
//       payload: message,
//     });
//   } finally {
//     dispatch({
//       type: actions.SAVE_LOADING_REQUIREMENTS_URL,
//       payload: false,
//     });
//   }
// };

export const deleteRequirementsMonitor =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_MONITOR,
        payload: true,
      });
      await RequirementsMonitorServices.deleteRequirementsMonitor(id);
      const { requirementsMonitors, requirementsMonitorsLength } =
        getState().requirementsMonitor;
      requirementsMonitors.splice(index, 1);
      dispatch({
        type: actions.GET_REQUIREMENTS_MONITOR,
        payload: {
          requirementsMonitors: requirementsMonitors,
          requirementsMonitorsLength: requirementsMonitorsLength - 1,
        },
      });
      dispatch({
        type: actions.REQUIREMENTS_MONITOR_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.REQUIREMENTS_MONITOR_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_MONITOR,
        payload: false,
      });
    }
  };

export const deleteRequirementsUrl =
  (id, index, _index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_URL,
        payload: true,
      });
      await RequirementsMonitorServices.deleteRequirementsUrl(id);
      // const { data, count } = getState().requirementsUrls.requirementsUrls;
      // let _data = data.slice();

      const { requirementsMonitors, requirementsMonitorsLength } =
        getState().requirementsMonitor;
      // requirementsMonitors[index] = resp.data;
      requirementsMonitors[index].list_plan_induccion.splice(_index, 1);
      dispatch({
        type: actions.GET_REQUIREMENTS_MONITOR,
        payload: {
          requirementsMonitors: requirementsMonitors,
          requirementsMonitorsLength: requirementsMonitorsLength,
        },
      });

      // dispatch({
      //   type: actions.GET_REQUIREMENTS_URL,
      //   payload: {
      //     data: _data,
      //     count: count - 1,
      //   },
      // });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_REQUIREMENTS_URL,
        payload: false,
      });
    }
  };

export const getRequirementDoc =
  (id, setLoader) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_DESCRIPTOR_MANUAL,
      //   payload: true,
      // });
      setLoader(true);
      const resp = await RequirementsMonitorServices.getRequirementDoc(id);
      downloadDocument(
        `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${resp.data.documento}`,
        "Solicitud plaza.docx"
      );
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_GENERAL_INFO,
      //   payload: message,
      // });
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      setLoader(false);
      // dispatch({
      //   type: actions.LOADING_DESCRIPTOR_MANUAL,
      //   payload: false,
      // });
    }
  };
